export default __webpack_public_path__ + "static/media/pet-friendly.9d915a9e.svg";